"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavAvatarIcon = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Avatar_1 = tslib_1.__importDefault(require("@mui/material/Avatar"));
const styles_1 = require("@mui/material/styles");
/**
 *
 * Component is used internally in the {@link Rail} and {@link PageLayout} (Servicenavigation) to display
 * a avatar if no icon is provided.
 *
 * Why is this a separate component?
 * The sizing is different from the original material component.
 *
 * @internal
 *
 * @example Usage
 * ```tsx
 * <NavAvatarIcon text="ES" />
 * ```
 */
exports.NavAvatarIcon = (0, styles_1.styled)(({ text, ...avatarProps }) => (react_1.default.createElement(Avatar_1.default, { ...avatarProps }, text)))(({ theme }) => ({
    backgroundColor: theme.palette.action.active,
    fontSize: "1rem",
    height: theme.spacing(4),
    textTransform: "uppercase",
    width: theme.spacing(4),
}));
exports.default = exports.NavAvatarIcon;
